import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaLock } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import MainLogo from '../AllImages/GetItRight.png';
import PartyMembers from './PartyMembers';
import MusicPage from './MusicPage';
import ItineraryPage from './ItineraryPage';
import AuditionForm from './AuditionForm';
import DownPay from '../MainPage/DownPaymentPage';
import Support from './Support';
import SettingsPage from './SettingsPage';
import OnlineRehearsal from './OnlineRehearsal';

// Japanese theme assets
import Cherry from '../Assets/Cherry.png';

// Firebase imports
import { getAuth, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';


// Falling petals
function FallingPetals({ count = 15 }) {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-10">
      {Array.from({ length: count }).map((_, i) => {
        const delay = Math.random() * 20;
        const duration = 20 + Math.random() * 20;
        const startX = Math.random() * 100;
        const drift = (Math.random() - 0.5) * 20;
        return (
          <motion.img
            key={i}
            src={Cherry}
            className="absolute w-4 h-4"
            style={{ left: `${startX}%` }}
            initial={{ y: '-10vh', opacity: 1, rotate: Math.random() * 360 }}
            animate={{ y: '110vh', x: `${startX + drift}%`, opacity: 0, rotate: Math.random() * 720 }}
            transition={{ repeat: Infinity, duration, delay, ease: 'linear' }}
          />
        );
      })}
    </div>
  );
}

const DashBoard = () => {
  const auth = getAuth();
  const user = auth.currentUser;
  const uid = user?.uid;
  const name = user?.displayName || user?.email || 'Invitado';

  const [activeTab, setActiveTab] = useState('audition');
  const [showDropdown, setShowDropdown] = useState(false);
  const [studentAccepted, setStudentAccepted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!uid) return;
    (async () => {
      const ref = doc(db, 'reservations', uid);
      const snap = await getDoc(ref);
      if (snap.exists()) setStudentAccepted(snap.data().studentAccepted);
    })();
  }, [uid]);

  const lockedTabs = {
    participants: !studentAccepted,
    itinerary: !studentAccepted,
    payment: !studentAccepted,
    music: !studentAccepted,
    'music-competition': !studentAccepted,
    'online-rehearsals': !studentAccepted,
  };

  const handleSignOut = async () => {
    await signOut(auth);
    navigate('/');
  };

  const navItemClass = (key) => {
    const active = activeTab === key;
    const locked = lockedTabs[key];
    return [
      'flex items-center space-x-1 transition-colors',
      active ? 'text-red-600' : 'text-black hover:text-red-600',
      locked && 'opacity-50 cursor-not-allowed line-through hover:text-black'
    ].filter(Boolean).join(' ');
  };

  const renderNav = () => (
    ['audition','participants','itinerary','payment','music','music-competition','online-rehearsals'].map(key => (
      <button
        key={key}
        disabled={lockedTabs[key]}
        onClick={() => { if (!lockedTabs[key]) setActiveTab(key); }}
        className={navItemClass(key)}
      >
        <span>{{
          audition: 'Audición',
          participants: 'Participantes',
          itinerary: 'Itinerario',
         
          music: 'Música',
   
          'online-rehearsals': 'Ensayos'
        }[key]}</span>
        {lockedTabs[key] && <FaLock />}
      </button>
    ))
  );

  return (
    <div className="relative font-sans min-h-screen bg-white text-black">
   
      <FallingPetals />

      <header className="relative bg-white border-b-2 border-red-600 z-20">
        <div className="container mx-auto flex items-center justify-between px-6 py-4">
          <div className="flex items-center space-x-6">
            <img src={MainLogo} alt="Logo" className="h-10" />
            <nav className="hidden md:flex space-x-4">
              {renderNav()}
            </nav>
          </div>
          <div className="relative">
            <button onClick={() => setShowDropdown(!showDropdown)} className="flex items-center space-x-1 text-black">
              <span>{name}</span>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {showDropdown && (
              <div className="absolute right-0 mt-2 w-48 bg-white border border-red-600 rounded shadow-lg text-black">
                <div className="flex flex-col p-2 space-y-1">
                  {renderNav()}
                  <button onClick={() => { setActiveTab('support'); setShowDropdown(false); }} className="text-black hover:text-red-600">Soporte</button>
                  <hr className="border-red-600" />
               
                  <button onClick={handleSignOut} className="text-black hover:text-red-600">Cerrar sesión</button>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>

      <main className="container mx-auto px-6 py-8 z-10">
        {activeTab === 'audition' && (studentAccepted ? <DownPay uid={uid} name={name}/> : <AuditionForm uid={uid} name={name}/>)}
        {activeTab === 'participants' && <PartyMembers uid={uid} name={name} />}
        {activeTab === 'itinerary' && <ItineraryPage uid={uid} name={name} />}
   
        {activeTab === 'music' && <MusicPage uid={uid} name={name} />}
      
        {activeTab === 'online-rehearsals' && <OnlineRehearsal uid={uid} name={name} />}
        {activeTab === 'support' && <Support uid={uid} name={name} />}
        {activeTab === 'settings' && <SettingsPage uid={uid} name={name} />}
      </main>
    </div>
  );
};

export default DashBoard;
